import React, {useState, useEffect} from 'react';
import { observer } from 'mobx-react';
import Intro from '../Components/Chat/Intro';
import BroadcastMessage from '../Components/Chat/BroadcastMessage';

const Welcome = observer((props) => {
  const [hasMatchingBroadcast, setHasMatchingBroadcast] = useState(false);
  
  useEffect(() => {
    
    if(props.store.SessionStore.matchingBroadcasts.length){
      setHasMatchingBroadcast(true);
    }

  }, [props.store.SessionStore.matchingBroadcasts]);

  const noMatchingBroadcast = () =>{
    setHasMatchingBroadcast(false);
  }
  
  return (
    <>
    <div class="row">   
        <div className="col-md p-4 text-start">
          {!hasMatchingBroadcast ? (<Intro {...props} />) : (<BroadcastMessage {...props} noMatchingBroadcast={noMatchingBroadcast} />) }
        </div>
      </div>
    </>
  );
});

export default Welcome;